import { AddressModel as AddressApi } from '@/http/models/address/Address'
import { toast } from 'sonner'

import { useCallback, useState } from 'react'

import { AddressModel, AddressResponses } from '@/types'

export const useOrderAddresses = (userId?: string) => {
  const [addresses, setAddresses] = useState<AddressModel.Address[]>([])
  const [loading, setLoading] = useState(false)

  const fetchAddresses = useCallback(async () => {
    if (!userId) return
    setLoading(true)
    try {
      const response = await AddressApi.getList({
        query: { customer_id: userId, length: 50 },
      })
      if (response.success && response.data?.result) {
        setAddresses(response.data.result)
      }
    } catch (error) {
      console.error('Failed to fetch addresses:', error)
    } finally {
      setLoading(false)
    }
  }, [userId])

  const createAddress = async (data: any) => {
    const response = await AddressApi.create({ body: data })
    if (response.success) {
      toast.success('Address added successfully')
      fetchAddresses()
      return response.data?.result
    } else {
      toast.error('Failed to add address')
      return null
    }
  }

  return {
    addresses,
    loading,
    fetchAddresses,
    createAddress,
  }
}
